import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ADMINISTRATOR_FEATURE_KEY,
  AdministratorState,
  administratorAdapter,
} from './administrator.reducer';

// Lookup the 'Administrator' feature state managed by NgRx
export const selectAdministratorState =
  createFeatureSelector<AdministratorState>(ADMINISTRATOR_FEATURE_KEY);

const { selectAll, selectEntities } = administratorAdapter.getSelectors();

export const GetUserLoginLogsList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.usersLoginLogsList
);

export const GetUserLoginLogsHistoryList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.loginLogsHistoryData
);

export const GetAdminOrganizationList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminOrganizationData
);

export const GetAdminOrganizationModalList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminOrganizationModaldata
);

export const GetConversionList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.conversionList
);

export const GetAreaBasedConversionList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.areaBasedConversionList
);

export const GetTransportList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.transportList
);

export const GetAdminRecycledList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminRecycledList
);

export const GetAdminMaterialList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminMaterialList
);

export const GetAdminIngredientsList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminIngredientsList
);

export const GetEnergyandAncillaryList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.energyandAncillaryList
);

export const GetProcessingCustomConversionList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.processingCustomConversionList
);

export const GetstorageList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.storageList
);

export const GetWasteList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.wasteList
);

export const GetRefrigeratedTruck = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.refrigeratedTruckList
);

export const GetProcessingCustomTruck = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.processingCustomTruckList
);

export const GetEolList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.eolList
);

// For material-types & Recyclability & Compostability & Combustibility
export const GetOtherDataMaterialList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataMaterialList
);

export const GetOtherDataCircularEconomyParameterList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataCircularEconomyParameterList
);

export const GetOtherDataPalletTypeList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataPalletTypeList
);

export const GetOtherDataProjectStatusList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataProjectStatusList
);

export const GetOtherDataScenarioStatusList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataScenarioStatusList
);

export const GetOtherDataEquivalancyUnitsList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataEquivalancyUnitsList
);

export const GetConversionMappingList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.conversionMappingList
);

export const GetRecycledContentList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.recycledContent
);

export const GetOtherDataCountryIndetifiersList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.otherDataCountryIndetifiersList
);

export const GetProductPackagingRatioList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.productPackagingRatioList
);

export const GetMiscSimulationList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.miscSimulationList
);

export const GetLogEntries = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.logEntriesListData
);
export const GetCountryList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.countryList
);

export const GetStateList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.stateList
);

export const GetCityList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.cityList
);

export const GetImportList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.importList
);

export const GetNewsList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.newsList
);

export const GetRolesList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.rolesList
);

export const GetStateListById = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.stateListById
);

export const GetMaterialInfoList = createSelector(
  selectAdministratorState,
  (state: AdministratorState) => state.adminMaterialModaldata
);
